import { Component, Host, h, Prop, Event } from "@stencil/core";
import type { EventEmitter } from "@stencil/core";

import type { PageConfig } from "../../../../config/page-configs/page-configs";
import { mesosConfig } from "../../../../config/mesos-config";
import { FeatureButton } from "../../../../config/feature-buttons";

import { fixIEShadowDom } from "../../../../utils/fix-ie-shadow-dom";

@Component({
    tag: "c-welcome",
    styleUrl: "c-welcome.scss",
})
export class CWelcome {
    @Prop() pageConfig: PageConfig;

    @Event() featureButton: EventEmitter;

    private changeLang(type: string) {
        const bot = document.getElementsByTagName("ba-chatbot")[0];
        switch (type) {
            case "cLang": {
                return bot.setAttribute("page-id", "form/form-assistant-ua");
            }
            case "deForm": {
                return bot.setAttribute("page-id", "form/form-de");
            }
            case "uaForm": {
                return bot.setAttribute("page-id", "form/form-ua");
            }
        }
    }

    private readonly language = localStorage.getItem("FormLang");
    private readonly start = localStorage.getItem("StartFormular");

    getFeatureButtons(buttons: FeatureButton[], small?: boolean) {
        return buttons.map((button) => {
            const buttonEnabledOnMesos = mesosConfig[button.mesosId];
            if (buttonEnabledOnMesos) {
                switch (button.message) {
                    case "change_language": {
                        return (
                            <button
                                class={small ? "welcome-small-button" : ""}
                                onClick={() => this.changeLang("cLang")}
                                data-analytics-track="true"
                                data-analytics-action="ButtonClicks TCB: Klick"
                                data-analytics-value="Change Language"
                                data-analytics-name="TCB: Language Button"
                                data-analytics-category="TCB | ButtonClicks"
                            >
                                {button.text}
                            </button>
                        );
                    }
                    case "form_de": {
                        return (
                            <button
                                class={small ? "welcome-small-button" : ""}
                                onClick={() => this.changeLang("deForm")}
                                data-analytics-track="true"
                                data-analytics-action="ButtonClicks TCB: Klick"
                                data-analytics-value="Open Formular German"
                                data-analytics-name="TCB: Form German Button"
                                data-analytics-category="TCB | ButtonClicks"
                            >
                                {button.text}
                            </button>
                        );
                    }
                    case "form_ua": {
                        return (
                            <button
                                class={small ? "welcome-small-button" : ""}
                                onClick={() => this.changeLang("uaForm")}
                                data-analytics-track="true"
                                data-analytics-action="ButtonClicks TCB: Klick"
                                data-analytics-value="Open Formular Ukraine"
                                data-analytics-name="TCB: Form Ukraine Button"
                                data-analytics-category="TCB | ButtonClicks"
                            >
                                {button.text}
                            </button>
                        );
                    }
                    default: {
                        return (
                            <button
                                class={small ? "welcome-small-button" : ""}
                                onClick={() => this.featureButton.emit(button)}
                                data-analytics-track="true"
                                data-analytics-action="ButtonClicks TCB: Klick"
                                data-analytics-value={button.text}
                                data-analytics-name="TCB: Welcome Button"
                                data-analytics-category="TCB | ButtonClicks"
                            >
                                {button.text}
                            </button>
                        );
                    }
                }
            }
        });
    }

    render() {
        return (
            <Host>
                <section class="text-container">
                    <div
                        id="cb-welcome-text"
                        innerHTML={this.pageConfig.welcome.text}
                    >
                        {this.pageConfig.welcome.info && (
                            <div class="info-container">
                                <i
                                    id="info-icon"
                                    aria-hidden="true"
                                    class="info-icon"
                                ></i>
                                <span
                                    id="info-text"
                                    class="info-text"
                                    innerHTML={fixIEShadowDom(
                                        this.pageConfig.welcome.info,
                                        "c-bubble-info"
                                    )}
                                ></span>
                            </div>
                        )}
                    </div>
                    {this.start && this.language && (
                        <div class="svg-container">
                            <c-form-progress
                                type="vertical"
                                language={this.language}
                            />
                        </div>
                    )}
                    {this.pageConfig.welcome.additionalContent && (
                        <div id="cb-welcome-add-content">
                            <span
                                innerHTML={
                                    this.pageConfig.welcome.additionalContent
                                        .firstText
                                }
                            ></span>
                            <div id="cb-welcome-buttons">
                                {this.getFeatureButtons(
                                    this.pageConfig.welcome.additionalContent
                                        .buttons,
                                    true
                                )}
                            </div>
                            {this.pageConfig.welcome.additionalContent
                                .secondText && (
                                <span
                                    innerHTML={
                                        this.pageConfig.welcome
                                            .additionalContent.secondText
                                    }
                                ></span>
                            )}
                        </div>
                    )}
                    <div id="cb-welcome-button">
                        {this.getFeatureButtons(
                            this.pageConfig.welcome.buttons
                        )}
                    </div>
                    <div
                        id="cb-welcome-disclaimer"
                        class="disclaimer"
                        innerHTML={this.pageConfig.welcome.disclaimer}
                    ></div>
                </section>
            </Host>
        );
    }
}
